// extracted by mini-css-extract-plugin
module.exports = {"bottomSection":"qWWD7sNA","menuWrapper":"lrMIgkWw","badge":"DeXZpBLD","moreFilterPill":"JR2CN7qC"};